export default "__VITE_ASSET__B7Tmj6FG__"